"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dcCore = require("dc-core");
var _ServiceRegistry = _interopRequireDefault(require("../util/ServiceRegistry"));
var _AppConstants = require("../constants/AppConstants");
var _Enums = _interopRequireDefault(require("../constants/Enums"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

class ConflictingToolsService {
  constructor() {
    this.init = () => {
      _ServiceRegistry.default.getService("AdobeViewer").getAPIs().then(apis => {
        this.viewSdkApis = apis;
        apis.registerBeforeRHPOpenCallback(async toolId => {
          await this.closeConflictingTools(_Enums.default.RHP, toolId);
        }, {
          isSave: true
        });
        apis.registerBeforeQuickToolActivatedCallback(async toolId => {
          await this.closeConflictingTools(_Enums.default.QUICK_TOOLS, toolId);
        }, {
          isSave: true
        });
        apis.registerBeforeNavigationBarToolActivatedCallback(async toolId => {
          await this.closeConflictingTools(_Enums.default.NAVIGATION_BAR, toolId);
        }, {
          isSave: true
        });
        apis.subscribeToPDFEditOperations(data => {
          if (data.startsWith("cropPages") || data.startsWith("numberPages")) {
            this.appStore.shouldSetAssetInfo = true;
          }
        });
        _dcCore.providers["tools-board-provider"]().then(toolsBoardProvider => {
          toolsBoardProvider.beforeToolActivated(async toolId => {
            await this.closeConflictingTools(_Enums.default.TOOLS_BOARD, toolId);
          }, {
            isSave: true
          });
          // eslint-disable-next-line no-unused-vars
          toolsBoardProvider.beforeVerbTileToolActivated(async toolId => {}, {
            isSave: true
          });
          toolsBoardProvider.beforeToolActivated(async toolId => {
            if (this.appStore.shouldSetAssetInfo && toolId === "group-edit") {
              const buffer = await apis.getUpdatedPDFBuffer(false);
              const fileBlob = new Blob([new Uint8Array(buffer)], {
                type: this.appStore.previewMetadata.mimeType
              });
              apis.setAssetInfo({
                fileObjects: [new File([fileBlob], this.appStore.previewMetadata.fileName, {
                  type: this.appStore.previewMetadata.mimeType
                })]
              });
              this.appStore.shouldSetAssetInfo = false;
            }
          }, {
            isSave: false
          });
        });
      });
    };
    this.closeConflictingTools = (enteringToolType, enteringToolId) => {
      // eslint-disable-next-line max-len
      const toolsToClose = _AppConstants.conflictingTools.filter(toolsEntry => Array.isArray(toolsEntry[enteringToolType]) && (toolsEntry[enteringToolType].includes(enteringToolId) || toolsEntry[enteringToolType].length === 0));
      const closeToolsPromises = [];
      toolsToClose.forEach(toolsEntry => {
        Object.keys(toolsEntry).forEach(async type => {
          if (type !== enteringToolType) {
            switch (type) {
              case _Enums.default.TOOLS_BOARD:
                {
                  const closeToolsPromise = _dcCore.providers["tools-board-provider"]().then(toolsBoardProvider => {
                    const currentConfig = toolsBoardProvider.getConfig();
                    if (currentConfig && toolsEntry[type].includes(currentConfig.id)) {
                      return toolsBoardProvider.reset(enteringToolId);
                    }
                    return Promise.resolve();
                  });
                  closeToolsPromises.push(closeToolsPromise);
                  break;
                }
              case _Enums.default.QUICK_TOOLS:
                {
                  let closeToolsPromise;
                  const activeQuickTool = await this.viewSdkApis.getActiveQuickTool();
                  if (activeQuickTool && toolsEntry[type].includes(activeQuickTool)) {
                    closeToolsPromise = this.viewSdkApis.resetQuickTool();
                  }
                  closeToolsPromise = Promise.resolve();
                  closeToolsPromises.push(closeToolsPromise);
                  break;
                }
              case _Enums.default.RHP:
                {
                  let closeToolsPromise;
                  const currentRHPConfig = await this.viewSdkApis.getRHPConfig();
                  if (currentRHPConfig && toolsEntry[type].includes(currentRHPConfig.dropinId)) {
                    closeToolsPromise = this.viewSdkApis.closeRHPPanel();
                  }
                  closeToolsPromise = Promise.resolve();
                  closeToolsPromises.push(closeToolsPromise);
                  break;
                }
              case _Enums.default.NAVIGATION_BAR:
                {
                  const closeToolsPromise = Promise.resolve();
                  closeToolsPromises.push(closeToolsPromise);
                  break;
                }
              default:
                break;
            }
          }
        });
      });
      return Promise.all(closeToolsPromises);
    };
    this.viewSdkApis = null;
    this.appStore = _ServiceRegistry.default.getService("AppStore");
    this.appStore.getAppReadyPromise().then(() => this.init());
  }
}
var _default = exports.default = ConflictingToolsService;